<template>
  <div class="sidebar-filters">
    <b-button class="text-uppercase" ref="escape" variant="reset-all" @click.prevent="resetFilters()">
      <i class="fas fa-eraser" /> {{ 'Reset all filters' | translate }}
    </b-button>
    <organization-list-filter
      @edit="editComponentFilters($event, 'filter__quotation__customer__in')"
      @clean="cleanComponentFilters(['filter__quotation__customer__in'])"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { TYPES as QUOTATION_INSTALLMENT_TYPES } from '../../quotation/quotation-installment/store'
import CommonFiltersMixin from '../../common-filters/CommonFiltersMixin'

export default {
  name: 'QuotationInstallmentCommonFilters',
  mixins: [CommonFiltersMixin],
  computed: {
    ...mapGetters({
      filters: QUOTATION_INSTALLMENT_TYPES.GENERIC.quotation.quotationinstallment.LIST.GETTERS.filters
    })
  },
  methods: {
    ...mapActions({
      ...QUOTATION_INSTALLMENT_TYPES.GENERIC.quotation.quotationinstallment.LIST.ACTIONS
    })
  }
}
</script>
